

<vtr-widget-sub-app-transition
   [subApp]="subApp"
   [showSkeleton]="showSkeleton"
   [metricsParent]=""
   [title]="title">

</vtr-widget-sub-app-transition>

